import { render, staticRenderFns } from "./employee-post.vue?vue&type=template&id=496c3294&scoped=true"
import script from "./employee-post.vue?vue&type=script&lang=js"
export * from "./employee-post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c3294",
  null
  
)

export default component.exports